import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormPage } from '../../tailwindComponents/FormPage';
import {
  CustomerFormValues,
  emptyCustomerLegalEntity,
  emptyCustomerCorporateHierarchy,
  emptyCustomerCommercial,
  emptyCustomerCompliance,
  emptyCustomerClassification,
} from './types';
import { CustomerFormFields, customerFormSchema } from './CustomerFormFields';

export function CustomerForm({
  onSubmit,
  isSubmitting,
  header,
  pages,
  defaultValues,
}: {
  onSubmit: (data: CustomerFormValues) => void;
  isSubmitting: boolean;
  header: string;
  pages: { name: string; href: string; current: boolean }[];
  defaultValues?: Partial<CustomerFormValues>;
}) {
  const [currentStep, setCurrentStep] = useState(1);

  const methods = useForm({
    shouldUnregister: false,
    resolver: yupResolver(customerFormSchema),
    mode: 'onChange',
    defaultValues: {
      customerId: '',
      name: '',
      type: '',
      contactName: '',
      contactEmail: '',
      contactNumber: '',
      hqId: '',
      hqName: '',
      address: '',
      country: '',
      postcode: '',
      location: {
        lon: 0,
        lat: 0,
      },
      operatingHoursFrom: '08:30',
      operatingHoursTo: '19:00',
      notes: '',
      legalEntity: { ...emptyCustomerLegalEntity },
      contacts: [],
      locations: [],
      corporateHierarchy: { ...emptyCustomerCorporateHierarchy },
      commercial: { ...emptyCustomerCommercial },
      compliance: { ...emptyCustomerCompliance },
      ...emptyCustomerClassification,
      ...defaultValues,
    } as CustomerFormValues,
  });

  const { formState, control, setValue, clearErrors } = methods;

  return (
    <FormPage<CustomerFormValues>
      header={header}
      pages={pages}
      methods={methods}
      currentStep={currentStep}
      setCurrentStep={setCurrentStep}
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
    >
      <CustomerFormFields
        control={control}
        formState={formState}
        setValue={setValue}
        clearErrors={clearErrors}
      />
    </FormPage>
  );
}
